import React from 'react';
import { Box } from '@mui/material';
import styles from './MyCommunityPage.module.scss';
import Groups from './Groups';
import Connections from './Connections';
import Follow from './Follow';
import ComingSoon from 'components/ComingSoon';
import Followers from './Followers';
import Invitations from './Invitations';

const MyCommunityPage = ({ activeTab, activeListPage, changePage }) => {
  const isProduction = process.env.REACT_APP_ENV === 'production';
  return (
    <>
      {isProduction ? (
        <Box className={styles.comingSoonBlock}>
          <ComingSoon text="This section displays all your contacts, connections, groups, subscribers, and people you follow." />
        </Box>
      ) : (
        <Box className={styles.container}>
          {activeTab === 5 ? (
            <Groups />
          ) : activeTab === 1 ? (
            <Connections />
          ) : activeTab === 4 ? (
            <Invitations activeListPage={activeListPage} changePage={changePage} />
          ) : activeTab === 2 ? (
            <Follow />
          ) : activeTab === 3 ? (
            <Followers />
          ) : null}
        </Box>
      )}
    </>
  );
};
export default MyCommunityPage;
